import { APPINSIGHTS_STRINGS } from "constants/appInsightStrings";

import { appInsights } from "components/Telemetry/AppInsightsRef";

export default function useAppInsightsHandler() {
  const trackEvent = type => appInsights.trackEvent({ name: APPINSIGHTS_STRINGS[type] || type });

  const trackPageView = (name, isPageExit = false) => {
    if (isPageExit) appInsights.stopTrackPage({ name });
    else appInsights.startTrackPage({ name });
  };

  return { trackPageView, trackEvent };
}
